import { Relation } from "@/components/graphql/types/globalTypes";
import { Patient } from "@/redux/slice/auth/types/Patient";

type PatientList = Patient[];

export default function primaryProfileId(patientList: PatientList) {
  const patients = patientList || [];

  const profile = patients.find((profile: Patient) => profile?.relation === Relation.ME);

  return profile?.id;
}
